import { DECIMAL_DIGITS } from 'src/modules/common/constants';
import { LocalesEnum } from 'src/generated/operations';
import { formatNumericString } from './formatNumericString';
import { numericToLocalized } from './numericToLocalized';

export const numberFormatter = (number: string, locale: LocalesEnum, decimal = DECIMAL_DIGITS) => {
    const formattedString = formatNumericString(number);

    if (!formattedString) {
        return '';
    }

    return numericToLocalized(formattedString, decimal, locale);
};
